import { UiStringModel } from "./ui-string.model";

export interface GlobalConfig {
  uiStrings: UiStringModel;
  config: {
    stripeSCAEnabled: boolean;
    isMatomoTrackingEnabled: boolean;
    googleReCaptchaSiteKey: string;
    requireRecaptchaOnFreeBookings: boolean;
    requireRecaptchaOnPaidBookings: boolean;
    allowUATracking: boolean;
    allowGA4Tracking: boolean;
    stripePaymentRequestEnabled: boolean;
    fatZebraApiUrl: string;
    applePayApiUrl: string;
    googlePayApiUrl: string;
    connexPointApiUrl: string;
  }
}

export const getGlobalConfig = (): GlobalConfig => {
  return (window as any).global as GlobalConfig;
}

